import { Controller } from "@hotwired/stimulus";
import { isMoEmbedded } from "./embed";

// Inside the Salespath iframe there is no login page for the user to complete, so a panel fetch that
// comes back unauthenticated can't redirect. The common cause — the framed request's SameSite=Lax
// session cookie not riding third-party — is already handled by the partitioned embed cookie (#6a).
// This covers the remaining case: a genuinely evicted or expired partitioned cookie. Then the
// massimo-panel turbo frame's fetch follows Devise's redirect to the sign-in page, finds no matching
// <turbo-frame> in it, and Turbo fires `turbo:frame-missing` (which otherwise surfaces a raw "Content
// missing" error). We catch that and show a refresh-to-continue message instead — a browser refresh
// reloads the parent Salespath page, which mints a fresh token.
//
// Attached to the shell wrapper (see embed/show.html.erb), which contains the frame, so the bubbling
// `turbo:frame-missing` reaches it. Only active in the embed (data-mo-embedded); a no-op otherwise.
export default class extends Controller {
  connect() {
    this.onFrameMissing = this.onFrameMissing.bind(this);
    this.element.addEventListener("turbo:frame-missing", this.onFrameMissing);
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-missing", this.onFrameMissing);
  }

  onFrameMissing(event) {
    if (!isMoEmbedded()) {
      return;
    }

    // Take over from Turbo's default handling (which would raise "Content missing" or try to visit the
    // sign-in page as a full-page navigation inside the iframe).
    event.preventDefault();
    event.target.innerHTML = `
      <div class="flex flex-1 items-center justify-center p-6">
        <p class="max-w-xs text-center text-sm text-gray-600">
          Your session expired. Refresh the page to continue.
        </p>
      </div>
    `;
  }
}
